import React, { Suspense, lazy } from 'react';
import { Redirect, Switch } from 'react-router-dom';
import { LayoutSplashScreen, ContentRoute } from '../_metronic/layout';
import { BuilderPage } from './pages/BuilderPage';
import { DashboardPage } from './pages/DashboardPage';
import { MyPage } from './pages/MyPage';
import { DonaturPage } from './modules/Donatur/DonaturPage';
import { DonaturEdit } from './modules/Donatur/donatur-edit/DonaturEdit';
import { CollectorPage } from './modules/Collector/CollectorPage'; // View Page List request data transaksi yang akan di lakukan collect
import { CollectPage } from './modules/Collector/collect/CollectPage'; // View Page Request data ke Checker
import { CheckerPage } from './modules/Checker/CheckerPage';
import { CollectorPage2 } from './modules/Collector2/CollectorPage';
import { CollectPage2 } from './modules/Collector2/collect/CollectPage';
import { CheckerPage2 } from './modules/Checker2/CheckerPage';
// import {ReportPage} from './modules/Report/ReportPage'
import { shallowEqual, useSelector } from 'react-redux';
import { PrivateRoute } from './PrivateRoute'
import { ExportListPage } from './modules/ExportList/ExportListPage';
import { RoleChecker } from './RoleChecker';

const MasterDatapage = lazy(() =>
    import('./modules/MasterData/pages/MasterDataPage'),
);

const DonationPage = lazy(() =>
    import('./modules/Donation/pages/DonationPage'),
);
const AnalysisPage = lazy(() =>
    import('./modules/Analysis/pages/AnalysisPage'),
);

export default function BasePage() {

    const { role } = useSelector(
        (state) => ({ role: state.auth.user.role }),
        shallowEqual,
    );


    // List Roles Navigasi
    const donasi_roles = ['SuperAdmin', 'Fundraiser', 'DataProses', 'CustomerCare', 'AdminCabang', 'Pickup', 'FundCollCheck', 'KepalaCabang', 'Helpdesk', 'MitraEchannel'];
    const checker_roles = ['SuperAdmin', 'Checker', 'FundCollCheck', 'KepalaCabang']
    const donatur_roles = ['SuperAdmin', 'DataProses', 'CustomerCare', 'Fundraiser', 'AdminCabang', 'FundCollCheck', 'KepalaCabang'];
    const collector_roles = ['SuperAdmin', 'Collector', 'FundCollCheck', 'KepalaCabang'];
    const master_roles = ['SuperAdmin', 'DataProses', 'AdminCabang', 'Helpdesk', 'KepalaCabang'];
    const export_roles = ['SuperAdmin', 'DataProses', 'AdminCabang', 'Helpdesk', 'KepalaCabang'];
    const analysis_roles = ['SuperAdmin', 'Fundraiser', 'DataProses', 'CustomerCare', 'AdminCabang', 'Pickup', 'FundCollCheck', 'KepalaCabang', 'Helpdesk', 'MitraEchannel'];

    // const laporan_roles = ['SuperAdmin', 'DataProses', 'AdminCabang']
    // End List Roles

    return (
        <Suspense fallback={<LayoutSplashScreen />}>
            <Switch>
                {
                    /* Redirect from root URL to /dashboard. */
                    <Redirect exact from="/" to="/dashboard" />
                }

                {/* GLOBAL */}
                <ContentRoute path="/dashboard" component={DashboardPage} />
                <ContentRoute path="/builder" component={BuilderPage} />
                <ContentRoute path="/my-page" component={MyPage} />


                {/* DONASI ROLE */}
                <PrivateRoute role={RoleChecker('Read', 'donasi')} component={DonationPage} path="/donasi" />

                {/* MASTER ROLE */}
                <PrivateRoute role={RoleChecker('Read', 'master_data')} component={MasterDatapage} path="/master-data" />

                {/* CHECKER ROLE
                <PrivateRoute role={checker_roles.includes(role)} component={CheckerPage} path="/checker/:id/:status"
                              exact={true}/>
                <PrivateRoute role={checker_roles.includes(role)} component={CheckerPage} path="/checker" exact={true}/> */}

                {/*CHECKER ROLE 2*/}
                <PrivateRoute role={RoleChecker('Read', 'checker')} component={CheckerPage2} path="/checker/:id/:status"
                    exact={true} />
                <PrivateRoute role={RoleChecker('Read', 'checker')} component={CheckerPage2} path="/checker" exact={true} />

                {/* DONATUR ROLE */}
                <PrivateRoute
                    role={RoleChecker('Read', 'donatur')}
                    component={DonaturPage}
                    path="/donatur"
                    exact={true}
                />
                <PrivateRoute
                    role={RoleChecker('Edit Donatur', 'detail_donatur')}
                    component={DonaturEdit}
                    path="/donatur/:id/edit"
                    exact={true}
                />
                <PrivateRoute
                    role={RoleChecker('Create Donatur', 'daftar_donatur')}
                    component={DonaturEdit}
                    path="/donatur/new"
                    exact={true}
                />
                <PrivateRoute
                    role={RoleChecker('Edit Donatur', 'detail_donatur')}
                    component={DonaturEdit}
                    path="/donatur/:parent_uuid/:donatur_type"
                    exact={true}
                />

                {/* COLLECTOR ROLE */}
                {/* <PrivateRoute role={collector_roles.includes(role)} component={CollectPage} path="/collector/collect"
                              exact/>
                <PrivateRoute role={collector_roles.includes(role)} component={CollectorPage}
                              path="/collector/:id/:status"
                              exact/>
                <PrivateRoute role={collector_roles.includes(role)} component={CollectorPage} path="/collector"
                              exact/> */}

                {/* COLLECTOR 2 ROLE */}
                <PrivateRoute role={RoleChecker('Read', 'collector')} component={CollectPage2} path="/collector/collect"
                    exact />
                <PrivateRoute role={RoleChecker('Read', 'collector')} component={CollectorPage2}
                    path="/collector/:id/:status"
                    exact />
                <PrivateRoute role={RoleChecker('Read', 'collector')} component={CollectorPage2} path="/collector"
                    exact />
                <PrivateRoute role={RoleChecker('Read', 'daftar_export')} component={ExportListPage} path="/export-list" exact={true} />

                {/* LAPORAN ROLE */}
                {/*<PrivateRoute role={laporan_roles.includes(role)} component={ReportPage} path="/laporan"*/}
                {/*              exact/>*/}

                <PrivateRoute role={RoleChecker('Read', 'analisa')} component={AnalysisPage} path="/analysis" />

                <Redirect to="error/error-v1" />
            </Switch>
        </Suspense>
    );
}
